import React from "react";
import s from "./ItProjects.module.css";

export default function ItProjects() {
  return (
    <div className={s.modul_in_development}>
      Warning! The module is temporarily in development.
    </div>
  );
}
